import client from '@/lib/axios-client'
import type {
	DDSAttendance,
	DDSAttendanceQr,
	DDSAttendanceStatus,
	DDSCheckInResult,
	DDSMood,
} from '@/types'

const DDS_URL = '/dds'

export async function closeAttendance(
	ddsId: string,
): Promise<DDSAttendanceStatus> {
	const response = await client.post(`${DDS_URL}/${ddsId}/attendance/close`)
	return response.data.data
}

export async function getAttendanceQr(ddsId: string): Promise<DDSAttendanceQr> {
	const response = await client.get(`${DDS_URL}/${ddsId}/attendance/qr`)
	return response.data.data
}

export async function getAttendance(ddsId: string): Promise<DDSAttendance> {
	const response = await client.get(`${DDS_URL}/${ddsId}/attendance`)
	return response.data.data
}

export async function checkIn(
	token: string,
	mood: DDSMood,
): Promise<DDSCheckInResult> {
	const response = await client.post(`${DDS_URL}/attendance/check-in`, {
		token,
		mood,
	})
	return response.data.data
}
